<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-new-window`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 6v4H6v28h36V28h4v12.2c0 .994-.985 1.8-2.2 1.8H4.2C2.985 42 2 41.194 2 40.2V7.8C2 6.806 2.985 6 4.2 6H24zm20 0a2 2 0 012 2v14h-4v-9.172l-11.95 11.95a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414L39.17 9.999 30 10V6h14z"/></svg>
</template>
<script>

export default {
  name: 'IconNewWindow',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
